import {Filter} from './Filter'

/**
 * Recommendations in the context of a product should contain the id of the product for which the
 * recommendation will be generated. For example, to get a list of products similar to product A,
 * provide the product ID of A.
 */
export class ProductFilter implements Filter {
    enableMultiple: boolean
    urlParam: string

    /** Filter value, product id to filter */
    value: string;

    /** @param filterValue Product id to filter */
    constructor(filterValue: string) {
        this.enableMultiple = true
        this.urlParam = 'filterProduct'
        this.value = filterValue
    }
}
